(function() {
	'use strict';

	const T = window.bundlerSliderTranslations || {};
	const BUNDLE_SELECTOR = '[data-bundle]';
	const PRODUCTS_WRAPPER_SELECTOR = '.bndlr-inner-products-container > div:has(.bndlr-product)';
	const PRODUCT_SELECTOR = '.bndlr-product';
	const BUNDLE_TITLE_SELECTOR = '.bndlr-bundle-title';
	const BUNDLE_DESCRIPTION_SELECTOR = '.bndlr-bundle-description';
	const MIN_PRODUCTS_FOR_LIST = 2;

	function initAllBundles() {
		const bundles = document.querySelectorAll(BUNDLE_SELECTOR);
		if (bundles.length === 0) return false;

		// Titre/description : appliqués à TOUS les lots présents, y compris ceux que
		// la mise en forme « liste ticket » ignore ensuite (moins de 2 produits, etc.).
		bundles.forEach(translateBundleHeader);

		relocateMixMatchBundles();

		const filterType = (window.bundlerSliderConfig && window.bundlerSliderConfig.bundleType) || 'classic';
		let processedCount = 0;

		bundles.forEach(function(bundle) {
			if (bundle._bcsInitialized) return;

			const container = bundle.querySelector('.bndlr-container');
			const isMixMatch = container && container.classList.contains('bndlr-mixnmatch');

			if (filterType === 'classic' && isMixMatch) {
				return;
			}
			if (filterType === 'mixnmatch' && !isMixMatch) {
				return;
			}

			const productsWrapper = bundle.querySelector(PRODUCTS_WRAPPER_SELECTOR);
			if (!productsWrapper) return;

			const products = productsWrapper.querySelectorAll(PRODUCT_SELECTOR);
			if (products.length < MIN_PRODUCTS_FOR_LIST) {
				bundle._bcsInitialized = true;
				return;
			}

			bundle._bcsInitialized = true;
			bundle.classList.add('bcs-classic');

			if (processedCount === 0) {
				moveBundleToTargetLocation(bundle);
			}

			injectToggle(bundle);
			injectValidityNotice(bundle);
			translateBundlerContent(bundle);

			processedCount++;
		});

		return processedCount > 0;
	}

	function relocateMixMatchBundles() {
		const target = document.getElementById('bundler-mixnmatch-zone');
		if (!target) return;

		document.querySelectorAll('[data-bundle]').forEach(function(bundle) {
			const container = bundle.querySelector('.bndlr-container');
			const isMixMatch = container && container.classList.contains('bndlr-mixnmatch');

			if (isMixMatch) {
				bundle.classList.add('bcs-mixnmatch');

				if (bundle.parentElement !== target) {
					target.appendChild(bundle);
				}

				applyMixMatchSlider(bundle);
			}
		});
	}

	function applyMixMatchSlider(bundle) {
		if (bundle._bcsMixMatchInitialized) return;

		const productsWrapper = bundle.querySelector(PRODUCTS_WRAPPER_SELECTOR);
		if (!productsWrapper) return;

		const products = productsWrapper.querySelectorAll(PRODUCT_SELECTOR);
		if (products.length < 2) return;

		bundle._bcsMixMatchInitialized = true;

		if (window._bcsDebug) diagnoseBundle(bundle);

		products.forEach(function(product) {
			annotateProductCard(product);
			bindCardClick(product);
		});

		injectMixMatchProgress(bundle);
		injectValidityNotice(bundle);
		translateBundlerContent(bundle);
		observeMixMatchBundle(bundle);
		listenBundlerEvents(bundle);
		syncMixMatchState(bundle);

		setTimeout(function() {
			syncMixMatchState(bundle);
		}, 500);
		setTimeout(function() {
			syncMixMatchState(bundle);
		}, 1500);

		hideNativeBundlerMessages(bundle);
	}

	function hideNativeBundlerMessages(bundle) {
		if (bundle._bcsMessagesObserver) return;
		bundle._bcsMessagesObserver = true;

		function maskMessages() {
			// Parcours des seuls nœuds texte (bien moins coûteux que querySelectorAll('*'))
			const walker = document.createTreeWalker(bundle, NodeFilter.SHOW_TEXT, null);
			let node;
			while ((node = walker.nextNode())) {
				const txt = (node.nodeValue || '').trim();
				if (!txt || txt.length > 200) continue;
				if (!/needs\s+\d+\s+more|manque\s+\d+|bundle\s+needs/i.test(txt)) continue;
				const el = node.parentElement;
				if (!el || el._bcsHiddenByPills) continue;
				if (el.closest('.bcs-mnm-progress')) continue;
				el._bcsHiddenByPills = true;
				el.style.cssText += 'position:absolute!important;left:-9999px!important;top:auto!important;width:1px!important;height:1px!important;overflow:hidden!important;pointer-events:none!important;';
			}
		}

		maskMessages();
		const obs = new MutationObserver(function() {
			if (bundle._bcsMaskTimer) clearTimeout(bundle._bcsMaskTimer);
			bundle._bcsMaskTimer = setTimeout(maskMessages, 50);
		});
		obs.observe(bundle, { childList: true, subtree: true, characterData: true });
		setTimeout(function() {
			obs.disconnect();
		}, 30000);
	}

	function diagnoseBundle(bundle) {
		console.group('[Bundler Pills] 🔍 Diagnostic du bundle mix & match');
		console.log('Bundle root :', bundle);
		if (window.bndlr && typeof window.bndlr.getBundles === 'function') {
			try {
				const allBundles = window.bndlr.getBundles();
				console.log('getBundles() :', allBundles);
			} catch (e) {
			}
		}
		const target = getMixMatchTarget(bundle);
		console.log('Cible :', target);
		console.groupEnd();
	}

	function listenBundlerEvents(bundle) {
		if (bundle._bcsEventsBound) return;
		bundle._bcsEventsBound = true;

		const events = [
			'bndlr:product-added', 'bndlr:product-removed', 'bndlr:bundle-updated',
			'bundler:product-added', 'bundler:product-removed', 'bundler:bundle-updated',
			'bndlr:mnm-updated', 'bndlr:state-changed'
		];
		events.forEach(function(evt) {
			document.addEventListener(evt, function() {
				setTimeout(function() {
					syncMixMatchState(bundle);
					translateBundleHeader(bundle);
				}, 100);
			});
			bundle.addEventListener(evt, function() {
				setTimeout(function() {
					syncMixMatchState(bundle);
					translateBundleHeader(bundle);
				}, 100);
			});
		});
	}

	function annotateProductCard(product) {
		const optionSelect = product.querySelector('select[name="option0"], .bndlr-select-option');
		let hasVariants = false;
		if (optionSelect) {
			hasVariants = optionSelect.options.length > 1;
		}
		product.setAttribute('data-bcs-has-variants', hasVariants ? '1' : '0');

		let isOOS = false;
		if (product.getAttribute('data-available') === 'false') {
			isOOS = true;
		}
		const addBtn = product.querySelector('.bndlr-add-to-bundle');
		if (addBtn && (addBtn.classList.contains('bndlr-disabled') || addBtn.hasAttribute('disabled'))) {
			isOOS = true;
		}
		if (optionSelect && optionSelect.options.length > 0) {
			const allDisabled = Array.from(optionSelect.options).every(function(o) {
				return o.disabled;
			});
			if (allDisabled) isOOS = true;
		}

		product.setAttribute('data-bcs-oos', isOOS ? '1' : '0');
		if (isOOS) {
			product.setAttribute('data-oos-label', T.out_of_stock || 'Épuisé');
		}
	}

	function bindCardClick(product) {
		if (product._bcsClickBound) return;
		product._bcsClickBound = true;

		product.addEventListener('click', function(e) {
			if (e.target.closest('.bndlr-product-options-container, select, option')) return;

			const link = e.target.closest('a');
			if (link) {
				e.preventDefault();
				e.stopPropagation();
			}

			if (product.getAttribute('data-bcs-oos') === '1') return;

			if (product._bcsClickInProgress) return;
			product._bcsClickInProgress = true;
			setTimeout(function() {
				product._bcsClickInProgress = false;
			}, 600);

			const bundle = product.closest('[data-bundle]');
			if (bundle && !bundle._bcsSelectedSet) bundle._bcsSelectedSet = new Set();
			const productKey = getProductKey(product);

			const isSelected = !!(bundle && productKey && bundle._bcsSelectedSet.has(productKey));

			if (!isSelected) {
				if (bundle) {
					const max = getMixMatchMax(bundle);
					const currentCount = bundle._bcsSelectedSet ? bundle._bcsSelectedSet.size : 0;
					if (max && currentCount >= max) {
						shakePill(product);
						showCapReachedToast(bundle, max);
						product._bcsClickInProgress = false;
						return;
					}
				}

				const optionSelect = product.querySelector('select[name="option0"], .bndlr-select-option');
				const variantSelect = product.querySelector('select[name="variant_id"]');

				if (optionSelect && !optionSelect.value) {
					const firstAvailable = Array.from(optionSelect.options).find(function(o) {
						return !o.disabled;
					});
					if (firstAvailable) {
						optionSelect.value = firstAvailable.value;
						optionSelect.dispatchEvent(new Event('change', { bubbles: true }));
					}
				}

				if (variantSelect && !variantSelect.value && variantSelect.options.length > 0) {
					variantSelect.value = variantSelect.options[0].value;
					variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
				}

				const addBtn = product.querySelector('.bndlr-add-to-bundle');
				if (addBtn) {
					const wasHidden = addBtn.classList.contains('bndlr-hidden');
					if (wasHidden) addBtn.classList.remove('bndlr-hidden');

					addBtn.click();

					if (wasHidden) {
						setTimeout(function() {
							addBtn.classList.add('bndlr-hidden');
						}, 50);
					}

					if (bundle && productKey) bundle._bcsSelectedSet.add(productKey);

					product.setAttribute('data-bcs-selected', '1');
					if (bundle) {
						setTimeout(function() {
							syncMixMatchState(bundle);
							product._bcsClickInProgress = false;
						}, 200);
					} else {
						product._bcsClickInProgress = false;
					}
				} else {
					product._bcsClickInProgress = false;
				}
			} else {
				if (bundle && productKey) bundle._bcsSelectedSet.delete(productKey);
				product.setAttribute('data-bcs-selected', '0');

				let removalTriggered = false;

				if (bundle && productKey) {
					const selectedZone = bundle.querySelector('.bndlr-mnm-selected-products');
					if (selectedZone) {
						const mirrors = selectedZone.querySelectorAll('.bndlr-product');
						for (let i = 0; i < mirrors.length; i++) {
							if (getProductKey(mirrors[i]) === productKey) {
								const closeBtn = mirrors[i].querySelector('.bndlr-close');
								if (closeBtn) {
									const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
									closeBtn.dispatchEvent(evt);
									removalTriggered = true;
									break;
								}
								const alt = mirrors[i].querySelector('.bndlr-product-overlay, [class*="remove"], [aria-label*="lose"], [aria-label*="emove"]');
								if (alt) {
									alt.click();
									removalTriggered = true;
									break;
								}
							}
						}
					}
				}

				if (!removalTriggered) {
					const addBtn = product.querySelector('.bndlr-add-to-bundle');
					if (addBtn) {
						const wasHidden = addBtn.classList.contains('bndlr-hidden');
						if (wasHidden) addBtn.classList.remove('bndlr-hidden');
						const evt = new MouseEvent('click', { bubbles: true, cancelable: true, view: window });
						addBtn.dispatchEvent(evt);
						if (wasHidden) setTimeout(function() {
							addBtn.classList.add('bndlr-hidden');
						}, 50);
						removalTriggered = true;
					}
				}

				if (window.bndlr && typeof window.bndlr.refresh === 'function') {
					setTimeout(function() {
						try {
							window.bndlr.refresh();
						} catch (e) {
						}
					}, 150);
				}

				if (!removalTriggered) {
					console.warn('[Bundler Pills] ⚠ Impossible de retirer ce produit. Recharger la page pour réinitialiser.');
				}

				if (bundle) setTimeout(function() {
					syncMixMatchState(bundle);
					product._bcsClickInProgress = false;
				}, 350);
				else product._bcsClickInProgress = false;
			}
		});
	}

	function getProductKey(productEl) {
		if (!productEl) return null;

		const vid = productEl.getAttribute('data-variant-id') || productEl.getAttribute('data-line-item-key');
		if (vid) return 'vid:' + vid;

		const variantSelect = productEl.querySelector('select[name="variant_id"]');
		if (variantSelect && variantSelect.value) return 'vid:' + variantSelect.value;
		if (variantSelect && variantSelect.options.length > 0) {
			const firstVid = variantSelect.options[0].value;
			if (firstVid) return 'vid:' + firstVid;
		}

		const pid = productEl.getAttribute('data-product-id');
		if (pid) return 'pid:' + pid;

		const idEl = productEl.querySelector('[class*="id_"]');
		if (idEl) {
			const m = idEl.className.match(/\bid_(\d+)\b/);
			if (m) return 'pid:' + m[1];
		}

		const link = productEl.querySelector('a[href*="/products/"]');
		if (link) {
			const m = link.getAttribute('href').match(/\/products\/([^?#\/]+)/);
			if (m) return 'href:' + m[1];
		}

		return null;
	}

	function syncMixMatchState(bundle) {
		const selectedZone = bundle.querySelector('.bndlr-mnm-selected-products');
		const productsWrapper = bundle.querySelector(PRODUCTS_WRAPPER_SELECTOR);
		if (!productsWrapper) return;

		if (!bundle._bcsSelectedSet) bundle._bcsSelectedSet = new Set();
		const localSet = bundle._bcsSelectedSet;

		const zoneKeys = new Set();
		if (selectedZone) {
			selectedZone.querySelectorAll('.bndlr-product').forEach(function(sp) {
				const k = getProductKey(sp);
				if (k) zoneKeys.add(k);
			});
		}

		// Une seule requête DOM + les clés calculées une seule fois par produit
		const products = productsWrapper.querySelectorAll('.bndlr-product');
		const keys = new Array(products.length);

		// Passe 1 : détecter les sélections et alimenter localSet
		for (let i = 0; i < products.length; i++) {
			const p = products[i];
			const k = getProductKey(p);
			keys[i] = k;
			if (!k) continue;
			const cl = p.classList;
			const hasSelectedClass = cl.contains('selected') || cl.contains('is-selected') ||
				cl.contains('in-bundle') || cl.contains('added') ||
				cl.contains('bndlr-selected') || cl.contains('bndlr-product-selected');
			let btnIndicatesSelected = false;
			const addBtn = p.querySelector('.bndlr-add-to-bundle');
			if (addBtn) {
				const btnText = (addBtn.textContent || '').toLowerCase().trim();
				if (/^(ajouté|added|selected|sélectionné|✓|in bundle|dans le lot)/.test(btnText)) btnIndicatesSelected = true;
				const bcl = addBtn.classList;
				if (bcl.contains('selected') || bcl.contains('is-selected') ||
					bcl.contains('added') || bcl.contains('bndlr-added')) btnIndicatesSelected = true;
			}
			if (hasSelectedClass || btnIndicatesSelected || zoneKeys.has(k)) {
				localSet.add(k);
			}
		}

		// Passe 2 : appliquer l'état (localSet complet) + annoter
		let appliedCount = 0;
		for (let i = 0; i < products.length; i++) {
			const p = products[i];
			const k = keys[i];
			const isSel = k && localSet.has(k);
			p.setAttribute('data-bcs-selected', isSel ? '1' : '0');
			if (isSel) appliedCount++;
			annotateProductCard(p);
		}

		const finalCount = Math.max(localSet.size, zoneKeys.size, appliedCount);
		updateMixMatchProgress(bundle, finalCount);

		if (window._bcsDebug && finalCount > 0 && !bundle._bcsFirstSelectionLogged) {
			bundle._bcsFirstSelectionLogged = true;
			console.log('[Bundler Pills] État courant :');
			console.log('  - Set local         :', Array.from(localSet));
			console.log('  - Zone Bundler      :', Array.from(zoneKeys));
			console.log('  - Pills marquées    :', appliedCount);
			console.log('  - Compteur affiché  :', finalCount);
		}

		if (window._bcsDebug) {
			console.log('[Bundler Pills] Sync → local:', localSet.size, '| zone:', zoneKeys.size, '| affichées:', appliedCount);
		}
	}

	function injectMixMatchProgress(bundle) {
		if (bundle.querySelector('.bcs-mnm-progress')) return;

		const wrap = document.createElement('div');
		wrap.className = 'bcs-mnm-progress';
		wrap.innerHTML =
			'<div class="bcs-mnm-progress-bar"><div class="bcs-mnm-progress-fill"></div></div>' +
			'<p class="bcs-mnm-progress-count">0 / 0</p>';

		const productsContainer = bundle.querySelector('.bndlr-inner-products-container, .bndlr-products-container');
		const totalContainer = bundle.querySelector('.bndlr-total-container');
		const buttonContainer = bundle.querySelector('.bndlr-bundle-button-container');

		if (productsContainer && productsContainer.parentNode) {
			productsContainer.parentNode.insertBefore(wrap, productsContainer.nextSibling);
		} else if (totalContainer && totalContainer.parentNode) {
			totalContainer.parentNode.insertBefore(wrap, totalContainer);
		} else if (buttonContainer && buttonContainer.parentNode) {
			buttonContainer.parentNode.insertBefore(wrap, buttonContainer);
		} else {
			const container = bundle.querySelector('.bndlr-container') || bundle;
			container.appendChild(wrap);
		}
	}

	function getMixMatchTarget(bundle) {
		// Cible fiable déjà mémorisée (config bundler ou data-attr) → on court-circuite
		// tout (lecture window.bndlr + TreeWalker). Une valeur heuristique reste, elle,
		// re-tentée pour pouvoir être remplacée par la valeur autoritaire dès qu'elle arrive.
		if (bundle._bcsTargetAuthoritative) return bundle._bcsCachedTarget;

		let cached = bundle._bcsCachedTarget || 0;

		if (window.bndlr && typeof window.bndlr.getBundles === 'function') {
			try {
				const bundles = window.bndlr.getBundles();
				const bundleId = bundle.getAttribute('data-bundle');
				let cfg = null;

				if (bundles) {
					if (Array.isArray(bundles)) {
						cfg = bundles.find(function(b) {
							return b && (String(b.id) === bundleId || String(b.bundle_id) === bundleId);
						}) || bundles[0];
					} else if (typeof bundles === 'object') {
						cfg = bundles[bundleId] || bundles[Object.keys(bundles)[0]];
					}
				}

				if (cfg) {
					const minFields = [
						'minimum_requirements_num',
						'min_products', 'minProducts',
						'min_items', 'minItems',
						'products_required', 'productsRequired',
						'min', 'minimum', 'min_quantity',
						'mnm_min', 'mnmMin', 'mix_match_min'
					];
					for (let i = 0; i < minFields.length; i++) {
						const v = cfg[minFields[i]];
						if (v && parseInt(v, 10) > 0) {
							bundle._bcsCachedTarget = parseInt(v, 10);
							bundle._bcsTargetAuthoritative = true;
							const maxRaw = cfg.minimum_requirements_n_max_products;
							if (maxRaw && parseInt(maxRaw, 10) > 0) {
								bundle._bcsCachedMax = parseInt(maxRaw, 10);
							}
							return bundle._bcsCachedTarget;
						}
					}
				}
			} catch (e) {
				console.warn('[Bundler Pills] Erreur lecture window.bndlr.getBundles() :', e);
			}
		}

		const containers = [bundle, bundle.querySelector('.bndlr-container'), bundle.querySelector('[class*="bndlr-mnm"]')].filter(Boolean);
		const targetAttrs = ['data-target', 'data-mnm-target', 'data-bundle-products-needed', 'data-min-products', 'data-mnm-min', 'data-products-required'];
		for (let c = 0; c < containers.length; c++) {
			for (let i = 0; i < targetAttrs.length; i++) {
				const v = containers[c].getAttribute(targetAttrs[i]);
				if (v && parseInt(v, 10) > 0) {
					bundle._bcsCachedTarget = parseInt(v, 10);
					bundle._bcsTargetAuthoritative = true;
					return bundle._bcsCachedTarget;
				}
			}
		}

		try {
			const walker = document.createTreeWalker(bundle, NodeFilter.SHOW_TEXT, null);
			let node;
			while ((node = walker.nextNode())) {
				const txt = (node.nodeValue || '').trim();
				if (!txt || txt.length > 200) continue;
				if (/manque\s+\d+|needs\s+\d+|^\s*\d+\s+more|\d+\s+(produit|item)/i.test(txt)) {
					const m = txt.match(/(\d+)/);
					if (m) {
						const missing = parseInt(m[1], 10);
						const localCount = (bundle._bcsSelectedSet ? bundle._bcsSelectedSet.size : 0);
						const computedTarget = localCount + missing;
						if (computedTarget > 0) {
							bundle._bcsCachedTarget = computedTarget;
							return computedTarget;
						}
					}
				}
			}
		} catch (e) {
		}

		if (cached > 0) return cached;

		return 3;
	}

	function getMixMatchMax(bundle) {
		if (typeof bundle._bcsCachedMax === 'undefined') {
			getMixMatchTarget(bundle);
		}
		return bundle._bcsCachedMax || null;
	}

	function shakePill(product) {
		product.classList.remove('bcs-shake');
		void product.offsetWidth;
		product.classList.add('bcs-shake');
		setTimeout(function() {
			product.classList.remove('bcs-shake');
		}, 600);
	}

	function showCapReachedToast(bundle, max) {
		if (bundle._bcsToastVisible) return;
		bundle._bcsToastVisible = true;

		const toast = document.createElement('div');
		toast.className = 'bcs-cap-toast';
		toast.textContent = 'Lot complet (max ' + max + ' produit' + (max > 1 ? 's' : '') + ')';
		bundle.appendChild(toast);

		requestAnimationFrame(function() {
			toast.classList.add('is-visible');
		});

		setTimeout(function() {
			toast.classList.remove('is-visible');
			setTimeout(function() {
				if (toast.parentNode) toast.parentNode.removeChild(toast);
				bundle._bcsToastVisible = false;
			}, 300);
		}, 2200);
	}

	function updateMixMatchProgress(bundle, selectedCount) {
		const wrap = bundle.querySelector('.bcs-mnm-progress');
		if (!wrap) return;
		const fill = wrap.querySelector('.bcs-mnm-progress-fill');
		const count = wrap.querySelector('.bcs-mnm-progress-count');

		const target = getMixMatchTarget(bundle);
		const safeSelected = Math.max(0, selectedCount || 0);
		const pct = target > 0 ? Math.min(100, (safeSelected / target) * 100) : 0;
		const isComplete = safeSelected >= target;

		if (fill) {
			fill.style.width = pct + '%';
			fill.classList.toggle('is-complete', isComplete);
		}
		if (count) {
			// 0 et 1 prennent le singulier (règle du français, langue principale) ;
			// les langues qui ne distinguent pas peuvent mettre la même chaîne dans les deux clés.
			const unit = safeSelected > 1 ? T.products_selected_other : T.products_selected_one;
			count.textContent = safeSelected + ' / ' + target + (unit ? ' ' + unit : '');
			count.classList.toggle('is-complete', isComplete);
		}
	}

	function observeMixMatchBundle(bundle) {
		if (bundle._bcsMnmObserver) return;
		bundle._bcsMnmObserver = true;

		const obs = new MutationObserver(function() {
			if (bundle._bcsMnmSyncTimer) clearTimeout(bundle._bcsMnmSyncTimer);
			bundle._bcsMnmSyncTimer = setTimeout(function() {
				const productsWrapper = bundle.querySelector(PRODUCTS_WRAPPER_SELECTOR);
				if (productsWrapper) {
					productsWrapper.querySelectorAll('.bndlr-product').forEach(function(p) {
						if (!p._bcsClickBound) {
							annotateProductCard(p);
							bindCardClick(p);
						}
					});
				}
				injectMixMatchProgress(bundle);
				syncMixMatchState(bundle);
			}, 160);
		});

		obs.observe(bundle, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'class'] });
	}

	// ════════════════════════════════════════════════
	// RÉDUCTION DU LOT (badge dynamique)
	// ════════════════════════════════════════════════
	function getBundleDiscount(bundle) {
		if (typeof bundle._bcsCachedDiscount !== 'undefined') return bundle._bcsCachedDiscount;
		if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return null;

		try {
			const bundles = window.bndlr.getBundles();
			const bundleId = bundle.getAttribute('data-bundle');
			let cfg = null;

			if (Array.isArray(bundles)) {
				cfg = bundles.find(function(b) {
					return b && (String(b.id) === bundleId || String(b.bundle_id) === bundleId);
				}) || bundles[0];
			} else if (bundles && typeof bundles === 'object') {
				cfg = bundles[bundleId] || bundles[Object.keys(bundles)[0]];
			}
			if (!cfg) return null;

			// Champs réels du bundler :
			//   discount_type : 'percentage' | 'fixed_amount' | 'fixed_price'
			//   percentage_value / fixed_amount_value / fixed_price_value
			const type = String(cfg.discount_type || 'percentage').toLowerCase();

			// 'fixed_price' = prix fixe du lot (pas une remise affichable en %/€) → pas de badge dynamique
			if (type === 'fixed_price') return null;

			const isFixed = type === 'fixed_amount';
			const raw = isFixed ? cfg.fixed_amount_value : cfg.percentage_value;
			const value = parseFloat(raw);
			if (isNaN(value) || value <= 0) return null;

			// On ne met en cache que lorsqu'une réduction valide est trouvée
			// (sinon on laisse une nouvelle tentative quand window.bndlr sera prêt)
			bundle._bcsCachedDiscount = { value: value, type: isFixed ? 'fixed_amount' : 'percentage' };
			return bundle._bcsCachedDiscount;
		} catch (e) {
			return null;
		}
	}

	function formatBundleBadge(bundle) {
		const d = getBundleDiscount(bundle);
		if (!d) return T.badge || '';

		// Arrondi propre : pas de décimale inutile (20 plutôt que 20.00)
		const num = d.value % 1 === 0 ? d.value : Math.round(d.value * 100) / 100;
		return d.type === 'fixed_amount' ? '-' + num + ' €' : '-' + num + '%';
	}

	function updateToggleBadge(bundle, badgeEl) {
		if (!badgeEl) return;
		let tries = 0;
		(function apply() {
			badgeEl.textContent = formatBundleBadge(bundle);
			// La config peut arriver après l'init : on retente tant qu'elle est absente
			if (!getBundleDiscount(bundle) && tries < 20) {
				tries++;
				setTimeout(apply, 300);
			}
		})();
	}

	function injectToggle(bundle) {
		if (bundle.previousElementSibling && bundle.previousElementSibling.classList.contains('bcs-toggle')) return;

		const toggle = document.createElement('button');
		toggle.type = 'button';
		toggle.className = 'bcs-toggle';
		toggle.setAttribute('aria-expanded', 'true');
		toggle.setAttribute('aria-controls', bundle.id);
		toggle.innerHTML =
			'<span>' +
			'<span class="bcs-toggle-label">' + T.toggle_open + '</span>' +
			'<span class="bcs-toggle-badge">' + T.badge + '</span>' +
			'</span>' +
			'<svg class="bcs-toggle-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
			'<polyline points="6 9 12 15 18 9"></polyline>' +
			'</svg>';

		bundle.parentNode.insertBefore(toggle, bundle);
		bundle.classList.add('bcs-expanded');
		const label = toggle.querySelector('.bcs-toggle-label');

		// Badge de réduction dynamique (lu depuis la config du bundle)
		updateToggleBadge(bundle, toggle.querySelector('.bcs-toggle-badge'));

		toggle.addEventListener('click', function() {
			const isOpen = toggle.getAttribute('aria-expanded') === 'true';
			toggle.setAttribute('aria-expanded', !isOpen);
			bundle.classList.toggle('bcs-expanded', !isOpen);
			label.textContent = isOpen ? T.toggle_closed : T.toggle_open;
		});
	}

	// ════════════════════════════════════════════════
	// DATE DE FIN DE L'OFFRE
	// ════════════════════════════════════════════════
	function getBundleValidity(bundle) {
		// undefined = config bundler pas encore chargée (→ il faut retenter)
		// null      = config lue mais pas de date de fin valide (→ ne rien faire)
		if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return undefined;

		try {
			const bundles = window.bndlr.getBundles();
			const bundleId = bundle.getAttribute('data-bundle');
			let cfg = null;

			if (Array.isArray(bundles)) {
				cfg = bundles.find(function(b) {
					return b && String(b.id) === bundleId;
				});
			} else if (bundles && typeof bundles === 'object') {
				cfg = bundles[bundleId];
			}

			if (!cfg) return undefined;

			const dateActive = (cfg.use_date_condition === 'true' || cfg.use_date_condition === true);
			if (!dateActive) return null;

			const dateFrom = cfg.date_from ? new Date(cfg.date_from) : null;
			const dateTo = cfg.date_to ? new Date(cfg.date_to) : null;

			if (dateFrom && isNaN(dateFrom.getTime())) return null;
			if (dateTo && isNaN(dateTo.getTime())) return null;

			if (!dateFrom && !dateTo) return null;

			return { from: dateFrom, to: dateTo };
		} catch (e) {
			console.warn('[Bundler] Erreur lecture validité :', e);
			return null;
		}
	}

	function injectValidityNotice(bundle, tries) {
		if (bundle.querySelector('.bcs-bundle-validity')) return;
		tries = tries || 0;

		const validity = getBundleValidity(bundle);

		// Config bundler pas encore prête → on retente (même résilience que le badge)
		if (typeof validity === 'undefined') {
			if (tries < 20) {
				setTimeout(function() {
					injectValidityNotice(bundle, tries + 1);
				}, 300);
			}
			return;
		}

		if (!validity || !validity.to) return;

		const now = new Date();
		if (validity.to.getTime() < now.getTime()) return;

		const lang = (document.documentElement.lang || 'fr').toLowerCase().split('-')[0];
		const localeMap = { fr: 'fr-FR', en: 'en-US', it: 'it-IT' };
		const locale = localeMap[lang] || 'fr-FR';

		const formattedDate = validity.to.toLocaleDateString(locale, {
			day: 'numeric',
			month: 'long',
			year: 'numeric'
		});

		const msPerDay = 24 * 60 * 60 * 1000;
		const daysLeft = Math.ceil((validity.to.getTime() - now.getTime()) / msPerDay);
		const isUrgent = daysLeft <= 7;

		const notice = document.createElement('div');
		notice.className = 'bcs-bundle-validity' + (isUrgent ? ' is-urgent' : '');
		notice.innerHTML =
			'<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">' +
			'<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>' +
			'<line x1="16" y1="2" x2="16" y2="6"></line>' +
			'<line x1="8" y1="2" x2="8" y2="6"></line>' +
			'<line x1="3" y1="10" x2="21" y2="10"></line>' +
			'</svg>' +
			'<span>' + (T.offer_valid_until || 'Offre valable jusqu\'au') + ' <strong>' + formattedDate + '</strong></span>';

		const productsContainer = bundle.querySelector('.bndlr-inner-products-container, .bndlr-products-container');
		if (productsContainer && productsContainer.parentNode) {
			productsContainer.parentNode.insertBefore(notice, productsContainer.nextSibling);
		} else {
			const mainContainer = bundle.querySelector('.bndlr-container');
			if (mainContainer) {
				mainContainer.insertBefore(notice, mainContainer.firstChild);
			}
		}
	}

	// ════════════════════════════════════════════════
	// TITRE / DESCRIPTION DU LOT (métaobjet bundle_translation)
	// ════════════════════════════════════════════════
	// Ces deux champs sont saisis par lot dans Bundler, qui n'a aucun système de
	// traduction : on les réécrit depuis window.bundlerBundleTranslations, alimenté
	// par le métaobjet « bundle_translation » (voir snippets/bundler-slider.liquid).
	function setBundleText(bundle, selector, value) {
		if (!value) return;

		const el = bundle.querySelector(selector);
		// Comparaison avant écriture : sans elle, on relancerait en boucle les
		// MutationObserver qui nous appellent.
		if (!el || el.textContent === value) return;

		el.textContent = value;
	}

	function translateBundleHeader(bundle) {
		// Lu à chaque appel : la config peut être injectée après ce script.
		const map = window.bundlerBundleTranslations || {};
		const bundleId = (bundle.getAttribute('data-bundle') || '').trim();
		if (!bundleId) return;

		const tr = map[bundleId];
		if (!tr) {
			// Pas d'entrée métaobjet → le texte saisi dans Bundler reste affiché.
			if (window._bcsDebug) {
				console.warn('[Bundler i18n] Aucune entrée « bundle_translation » pour le lot ' + bundleId);
			}
			return;
		}

		setBundleText(bundle, BUNDLE_TITLE_SELECTOR, tr.title);
		setBundleText(bundle, BUNDLE_DESCRIPTION_SELECTOR, tr.description);
	}

	function translateBundlerContent(bundle) {
		if (bundle._isTranslating) return;
		bundle._isTranslating = true;

		try {
			// Réappliqué ici pour profiter de l'observer de cette fonction : Bundler
			// reconstruit le widget à chaque changement d'état et restaure ses textes.
			translateBundleHeader(bundle);

			const replacements = [
				{ match: /^\s*Total\s*:?\s*$/i, replace: T.total + ' :' },
				{ match: /^\s*Quantit[éeyè]\s*:?\s*$/i, replace: T.quantity },
				{ match: /^\s*Quantity\s*:?\s*$/i, replace: T.quantity },
				{ match: /^\s*Ajouter au panier\s*$/i, replace: T.add_to_cart },
				{ match: /^\s*Add to cart\s*$/i, replace: T.add_to_cart },
				{ match: /^\s*Les remises seront appliqu[ée]es lors du paiement\.?\s*$/i, replace: T.discount_note },
				{ match: /^\s*Discounts will be applied at checkout\.?\s*$/i, replace: T.discount_note },
				{ match: /^\s*Add to bundle\s*$/i, replace: T.add_to_bundle },
				{ match: /^\s*Ajouter au lot\s*$/i, replace: T.add_to_bundle },
				{ match: /^\s*Your bundle\s*:?\s*$/i, replace: T.your_bundle + ' :' },
				{ match: /^\s*Votre lot\s*:?\s*$/i, replace: T.your_bundle + ' :' },
				{ match: /^\s*Out of stock\s*$/i, replace: T.out_of_stock },
				{ match: /^\s*\u00c9puis[ée]\s*$/i, replace: T.out_of_stock }
			];

			const dynamicPatterns = [
				{
					match: /Your bundle needs\s+(\d+)\s+more items?\.?/i,
					build: function(n) {
						return T.needs_more_prefix + ' ' + n + ' ' + T.needs_more_suffix + '.';
					}
				},
				{
					match: /Il manque\s+(\d+)\s+produits?\s+à votre lot\.?/i,
					build: function(n) {
						return T.needs_more_prefix + ' ' + n + ' ' + T.needs_more_suffix + '.';
					}
				}
			];

			const walker = document.createTreeWalker(bundle, NodeFilter.SHOW_TEXT, null);
			const textNodes = [];
			let node;
			while ((node = walker.nextNode())) {
				if (node.textContent.trim()) textNodes.push(node);
			}

			textNodes.forEach(function(textNode) {
				const original = textNode.textContent;
				const trimmed = original.trim();

				for (const rule of dynamicPatterns) {
					const match = trimmed.match(rule.match);
					if (match) {
						textNode.textContent = original.replace(trimmed, rule.build(match[1]));
						return;
					}
				}

				for (const rule of replacements) {
					if (rule.match.test(trimmed)) {
						textNode.textContent = original.replace(trimmed, rule.replace);
						return;
					}
				}
			});

			if (!bundle._translationObserver) {
				bundle._translationObserver = true;
				const translationObs = new MutationObserver(function() {
					translateBundlerContent(bundle);
				});
				translationObs.observe(bundle, { childList: true, subtree: true, characterData: true });
				setTimeout(function() {
					translationObs.disconnect();
				}, 5000);
			}
		} finally {
			setTimeout(function() {
				bundle._isTranslating = false;
			}, 100);
		}
	}

	function moveBundleToTargetLocation(bundle) {
		const target = document.querySelector('.buy-button-quantity-container');
		if (!bundle || !target) return;

		if (target.nextElementSibling && target.nextElementSibling.isSameNode(bundle)) return;

		target.insertAdjacentElement('afterend', bundle);
	}

	function observeForBundles() {
		// Callback débouncé : une rafale de mutations de page = un seul initAllBundles()
		let debTimer = null;
		function scheduleInit() {
			if (debTimer) clearTimeout(debTimer);
			debTimer = setTimeout(initAllBundles, 120);
		}
		const observer = new MutationObserver(scheduleInit);

		if (initAllBundles()) {
			observer.observe(document.body, { childList: true, subtree: true });
			setTimeout(function() {
				observer.disconnect();
			}, 20000);
			return;
		}

		let attempts = 0;
		const interval = setInterval(function() {
			attempts++;
			if (initAllBundles() || attempts >= 40) clearInterval(interval);
		}, 500);
		observer.observe(document.body, { childList: true, subtree: true });
		setTimeout(function() {
			observer.disconnect();
			clearInterval(interval);
		}, 20000);
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', observeForBundles);
	} else {
		observeForBundles();
	}
})();

if (document.readyState === 'complete') {
	initBundlerCart();
} else {
	window.addEventListener('load', initBundlerCart);
}

function initBundlerCart() {
	'use strict';

	let isRefreshing = false;
	let addCompleted = false;

	function neutralise() {
		const cd = document.querySelector('cart-drawer');
		if (!cd) return false;
		const proto = Object.getPrototypeOf(cd);
		if (!proto || proto._bundlerNeutralised) return true;
		if (typeof proto.renderContents !== 'function') return false;

		const original = proto.renderContents;
		proto.renderContents = function(parsedState) {
			try {
				return original.call(this, parsedState);
			} catch (err) {
				return null;
			}
		};
		proto._bundlerNeutralised = true;
		return true;
	}

	if (!neutralise()) {
		const mo = new MutationObserver(function() {
			if (neutralise()) mo.disconnect();
		});
		mo.observe(document.body, { childList: true, subtree: false });
		setTimeout(function() {
			mo.disconnect();
		}, 10000);
		document.addEventListener('shopify:section:load', neutralise);
	}

	const originalXHROpen = window.XMLHttpRequest.prototype.open;
	window.XMLHttpRequest.prototype.open = function(method, url) {
		if (typeof url === 'string' && url.indexOf('bundler-cart-call') !== -1) {
			const isAddCall = url.indexOf('/cart/add.js') !== -1;
			const isCartCall = url.indexOf('/cart.js') !== -1 && !isAddCall;

			this.addEventListener('load', function() {
				if (this.status < 200 || this.status >= 300) return;

				if (isAddCall) {
					addCompleted = true;
				} else if (isCartCall && addCompleted) {
					addCompleted = false;
					if (!isRefreshing) {
						isRefreshing = true;
						setTimeout(function() {
							refreshAndOpenDrawer().finally(function() {
								isRefreshing = false;
							});
						}, 300);
					}
				}
			});
		}
		return originalXHROpen.apply(this, arguments);
	};

	['bndlr:added-to-cart', 'bundler:added-to-cart', 'bundler:cart-updated'].forEach(function(evt) {
		document.addEventListener(evt, function() {
			if (!isRefreshing) {
				isRefreshing = true;
				setTimeout(function() {
					refreshAndOpenDrawer().finally(function() {
						isRefreshing = false;
					});
				}, 500);
			}
		});
	});

	async function refreshAndOpenDrawer() {
		const cartDrawer = document.querySelector('cart-drawer');
		if (!cartDrawer) return;

		try {
			const sectionId = cartDrawer.dataset.sectionId;
			const res = await fetch('/?sections=' + sectionId + ',cart-icon-bubble&_t=' + Date.now(), {
				cache: 'no-store',
				credentials: 'same-origin'
			});
			const sections = await res.json();

			const drawerHTML = sections[sectionId];
			if (!drawerHTML) {
				cartDrawer.open();
				return;
			}

			if (drawerHTML.indexOf('cart-item') === -1 && drawerHTML.indexOf('drawer__inner-empty') !== -1) {
				isRefreshing = false;
				setTimeout(function() {
					refreshAndOpenDrawer();
				}, 500);
				return;
			}

			const parser = new DOMParser();
			const doc = parser.parseFromString(drawerHTML, 'text/html');
			const newInner = doc.querySelector('#CartDrawer');
			const currentInner = document.getElementById('CartDrawer');

			if (newInner && currentInner) {
				currentInner.innerHTML = newInner.innerHTML;
			}

			if (sections['cart-icon-bubble']) {
				const doc2 = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
				const newBubble = doc2.querySelector('.shopify-section');
				const currentBubble = document.getElementById('cart-icon-bubble');
				if (newBubble && currentBubble) {
					currentBubble.innerHTML = newBubble.innerHTML;
				}
			}

			cartDrawer.classList.remove('is-empty');
			const drawerInner = cartDrawer.querySelector('.drawer__inner');
			if (drawerInner) drawerInner.classList.remove('is-empty');

			const overlay = cartDrawer.querySelector('#CartDrawer-Overlay');
			if (overlay) {
				overlay.addEventListener('click', cartDrawer.close.bind(cartDrawer));
			}

			cartDrawer.open();

		} catch (err) {
			try {
				cartDrawer.open();
			} catch (e) {
			}
		}
	}
}
